import React, { Component } from 'react';
import { Page, Layout, Card, FormLayout, TextField, Banner, SettingToggle, Text, Checkbox, Button, LegacyStack, ButtonGroup, PageActions, TextContainer, Select, Tooltip, InlineStack, Icon  } from '@shopify/polaris';
import { InfoMinor } from '@shopify/polaris-icons';
import { SkeletonPageCustom } from './SkeletonPageCustom';
import { ColorPickerCustom } from './ColorPickerCustom';
import { DesktopMajor, MobileMajor } from '@shopify/polaris-icons';
import { fetchApi } from './helpers/fetchApi';
import { isBannerDismissed, dismissBanner } from './helpers/bannerSession';
import { GlobalPlanBanners } from './GlobalPlanBanners';

export class QuickView extends Component {

    constructor(props, ref) {
        super(props);
        props.setIsLoading(true);

        this.saveChanges = this.saveChanges.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.discardChanges = this.discardChanges.bind(this);
        this.togglePreviewActive = this.togglePreviewActive.bind(this);

        this.state = { initState: {}, model: {}, loading: true, previewActive: true, previewDesktop: true, _bannerTick: true };
    }

    componentDidMount() {
        this.populateData();
        this.props.setSaveChanges(this.saveChanges);
        this.props.setDiscardChanges(this.discardChanges);
    }
    
    discardChanges(){
        this.setState({ model: Object.assign({}, this.state.initState) ,initState: Object.assign({}, this.state.initState) });
    }

    handleChange(fieldName, newValue) {
        window?.shopify?.saveBar?.show("satcb-save-bar");

        this.setState(prevState => {
            let model = Object.assign({}, prevState.model);
            model[fieldName] = newValue;
            const isDirty = JSON.stringify(this.state.initState) !== JSON.stringify(model);
            this.props.setIsDirty(isDirty);
            if(!isDirty){
                window?.shopify?.saveBar?.hide("satcb-save-bar");
            }
            return { model };
        });
    }

    handlePreview(previewDesktop) {
        this.setState({ previewDesktop: previewDesktop });
    }

    togglePreviewActive() {
        this.setState({ previewActive: !this.state.previewActive });
    }

    render() {

        return (
            this.state.loading ?
                <SkeletonPageCustom />
                :
                <Page title="Quick view">
                    <Layout>
                        <Layout.Section>
                            <GlobalPlanBanners common={this.props.common} url={window.location.search} />
                        </Layout.Section>
                        <Layout.Section>
                            <Card>
                                <Card.Section>
                                    <LegacyStack alignment="leading" spacing="tight">
                                    <LegacyStack.Item>
                                        <Icon source={InfoMinor} />
                                    </LegacyStack.Item>

                                    <LegacyStack.Item fill>
                                        <Text as="h3" variant="headingSm">
                                        What is Quick View?
                                        </Text>
                                        <div style={{ marginTop: 4 }}>
                                        <Text as="p" variant="bodyMd">
                                            Quick View lets customers see product details and add items to cart without leaving the current page.
                                        </Text>
                                        </div>
                                    </LegacyStack.Item>
                                    </LegacyStack>
                                </Card.Section>
                            </Card>
                        </Layout.Section>
                        {/* <Layout.Section>
                            <Banner
                                title="What is Quick view?"
                                status="info"
                            >
                                <p>Quick view will allow your customers to view details and Add-To-Cart form of any product on any page.</p>
                            </Banner>
                        </Layout.Section> */}
                        <Layout.Section>
                            <div id="preview" className={(this.state.previewDesktop ? 'desktop' : 'mobile') + (this.state.previewActive ? '' : ' preview-hidden')}>
                                <Card title="Preview" sectioned actions={[{ content: this.state.previewActive ? 'Collapse ↑' : 'Expand ↓', onAction: this.togglePreviewActive }]}>
                                    <Card.Section>
                                        <div className="satcb-preview-wrapper"
                                            style={{
                                                display: this.state.previewActive ? 'flex' : 'none',
                                            }}>
                                            <div id="satcb_quick_view_preview" style={{ display: this.state.previewActive ? 'flex' : 'none', boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)', gap: 32, alignItems: 'flex-start'}}>
                                                <div className={'satcb_quick_view' + (!this.state.previewDesktop && this.state.model.mobileButtonType === 'round' ? ' satcb-mobile-bt-round' : '') + (' satcb_qv_mobile_' + this.state.model.positionMobile)} style={{ backgroundColor: this.state.model.buttonBackgroundColor, color: this.state.model.buttonColor, borderColor: this.state.model.buttonBorderColor }}>
                                                    <span>{this.state.model.quickView_Translation}</span>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="13" viewBox="-139 144 20 13"><path d="M-119.3 150.2c-.2-.2-4.4-6-9.8-6s-9.6 5.8-9.8 6c-.2.2-.2.5 0 .8.2.2 4.4 6 9.8 6s9.6-5.8 9.8-6c.1-.3.1-.6 0-.8zm-9.8 5.5c-4 0-7.4-3.8-8.4-5.1 1-1.3 4.4-5.1 8.4-5.1s7.4 3.8 8.4 5.1c-1 1.2-4.4 5.1-8.4 5.1z"></path><path d="M-129.1 146.6c-2.2 0-3.9 1.8-3.9 4s1.8 4 3.9 4c2.2 0 3.9-1.8 3.9-4s-1.7-4-3.9-4zm0 6.6c-1.4 0-2.6-1.2-2.6-2.6 0-1.5 1.2-2.6 2.6-2.6s2.6 1.2 2.6 2.6c0 1.4-1.2 2.6-2.6 2.6z"></path></svg>
                                                </div>
                                            </div>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                                >
                                                <svg
                                                    width="40"
                                                    height="40"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                    d="M5 12H19M19 12L13 6M19 12L13 18"
                                                    stroke="#999"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </div>
                                            <div className="satcb-modal satcb-modal-open" style={{ display: 'flex',  padding:'10px 20px', borderRadius:'5px', boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)'}}>
                                                <div className="satcb-modal-dialog" style={{ position: 'relative' }}>
                                                {/* header / close */}
                                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <button
                                                    type="button"
                                                    aria-label="Close"
                                                    onClick={this.togglePreviewModalOpen}
                                                    style={{
                                                        background: 'transparent',
                                                        border: 0,
                                                        fontSize: 20,
                                                        cursor: 'pointer',
                                                        lineHeight: '20px',
                                                    }}
                                                    >
                                                    ×
                                                    </button>
                                                </div>

                                                <div id="satcb_quickView-shopper">
                                                    {/* Product content (storefront class names) */}
                                                    <div className="satcb_quick-title" style={{ marginBottom: 8 }}>
                                                    <b>Your product's name</b>
                                                    </div>

                                                    <div className="satcb_quick-priceBox" style={{ marginBottom: 12 }}>
                                                    <span className="satcb_quick-price" style={{ color: this.state.model.productPriceColor }}>
                                                        $19.99
                                                    </span>{' '}
                                                    <span
                                                        className="satcb_quick-comparePrice"
                                                        style={{
                                                        color: this.state.model.productComparePriceColor,
                                                        textDecoration: 'line-through',
                                                        marginLeft: 8,
                                                        }}
                                                    >
                                                        $29.99
                                                    </span>
                                                    </div>

                                                    <div className="satcb_quick-description" style={{ marginBottom: 16 }}>
                                                    Your product's description
                                                    </div>

                                                    {/* Action buttons (style driven by settings) */}
                                                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                                    <button
                                                        type="button"
                                                        className="satcb_quick-atc"
                                                        style={{
                                                        backgroundColor: this.state.model.atcBackgroundColor,
                                                        color: this.state.model.atcColor,
                                                        border: `1px solid ${this.state.model.atcBorderColor || 'transparent'}`,
                                                        padding: '10px 12px',
                                                        cursor: 'pointer',
                                                        borderRadius: 4,
                                                        }}
                                                    >
                                                        {this.state.model.addToCart_Translation}
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="satcb_quick-buyNow"
                                                        style={{
                                                        backgroundColor: this.state.model.buyNowBackgroundColor,
                                                        color: this.state.model.buyNowColor,
                                                        border: `1px solid ${this.state.model.buyNowBorderColor || 'transparent'}`,
                                                        padding: '10px 12px',
                                                        cursor: 'pointer',
                                                        borderRadius: 4,
                                                        }}
                                                    >
                                                        {this.state.model.buyNow_Translation}
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="satcb_quick-viewDetails"
                                                        style={{
                                                        backgroundColor: this.state.model.viewDetailsBackgroundColor,
                                                        color: this.state.model.viewDetailsColor,
                                                        border: `1px solid ${this.state.model.viewDetailsBorderColor || 'transparent'}`,
                                                        padding: '10px 12px',
                                                        cursor: 'pointer',
                                                        borderRadius: 4,
                                                        }}
                                                    >
                                                        {this.state.model.viewDetails_Translation}
                                                    </button>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </Card.Section>

                                    <LegacyStack alignment="center" distribution="center">
                                        <div style={{ display: this.state.previewActive ? 'block' : 'none' }}>
                                            <ButtonGroup segmented con>
                                                <Button pressed={this.state.previewDesktop} onClick={(newValue) => this.handlePreview(true)} icon={DesktopMajor}>Desktop preview</Button>
                                                <Button pressed={!this.state.previewDesktop} onClick={(newValue) => this.handlePreview(false)} icon={MobileMajor}>Mobile preview</Button>
                                            </ButtonGroup>
                                        </div>
                                    </LegacyStack>
                                </Card>
                            </div>
                        </Layout.Section>
                        <Layout.AnnotatedSection
                            title="Quick view state"
                        >
                            <SettingToggle action={{
                                content: this.state.model.enabled ? 'Disable' : 'Enable',
                                onAction: () => { this.handleChange('enabled', !this.state.model.enabled) }
                            }}
                                enabled={this.state.model.enabled}
                            >
                                Quick view is currently <Text as="span" fontWeight="semibold">{this.state.model.enabled ? 'enabled' : 'disabled'}</Text>.
                            </SettingToggle>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection title="Settings">
                            <Card sectioned>
                                <FormLayout>
                                    <Select
                                        label="Button layout on mobile"
                                        options={[{ label: 'Round', value: 'round' }, { label: 'Square', value: 'square' }]}
                                        onChange={(newValue) => this.handleChange('mobileButtonType', newValue)}
                                        value={this.state.model.mobileButtonType}
                                    />
                                    <Select
                                        label="Position on mobile"
                                        options={[{ label: 'Top Right', value: 'top_right' }, { label: 'Bottom Right', value: 'bottom_right' }, { label: 'Top Left', value: 'top_left' }, { label: 'Bottom Left', value: 'bottom_left' }]}
                                        onChange={(newValue) => this.handleChange('positionMobile', newValue)}
                                        value={this.state.model.positionMobile}
                                    />
                                    <LegacyStack vertical spacing="tight">
                                        <LegacyStack wrap={false} alignment="center" spacing="tight">
                                            <Checkbox
                                            label="Enable tracking"
                                            checked={this.state.model.trackingEnabled}
                                            onChange={(newValue) => this.handleChange('trackingEnabled', newValue)}

                                            />
                                            <Tooltip content="This attribute can be used for app auditing and will appear in your Shopify order details page. The attribute name is _Added from Sticky Add To Cart BOOSTER PRO's Quick view. This is not visible to your customers.">
                                            <div style={{ lineHeight: 'normal', marginLeft: '4px' }}>
                                                <Icon source={InfoMinor} color="inkLightest" />
                                            </div>
                                            </Tooltip>
                                        </LegacyStack>
                                    </LegacyStack>
                                    
                                    <TextContainer>
                                        {
                                            !isBannerDismissed('QuickView.DisablingQuickView') && (
                                            <Banner title="Disabling Quick view"
                                            onDismiss={() => {
                                                        dismissBanner('QuickView.DisablingQuickView');
                                                        this.setState((p) => ({ _bannerTick: (p._bannerTick || 0) + 1 }));
                                                    }}
                                            >
                                                <p>
                                                    To disable Quick view button on a product, add a <b>Quick view disabled</b> tag to it.
                                                </p>
                                            </Banner>
                                        )}
                                        
                                    </TextContainer>
                                </FormLayout>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection
                            title="Translations"
                        >
                            <Card sectioned>
                                <FormLayout>
                                    <FormLayout.Group>
                                        <TextField
                                            value={this.state.model.quickView_Translation}
                                            onChange={(newValue) => this.handleChange('quickView_Translation', newValue)}
                                            label="Quick view"
                                        />
                                        <TextField
                                            value={this.state.model.quantity_Translation}
                                            onChange={(newValue) => this.handleChange('quantity_Translation', newValue)}
                                            label="Quantity"
                                        />
                                    </FormLayout.Group>
                                    <FormLayout.Group>
                                        <TextField
                                            value={this.state.model.addToCart_Translation}
                                            onChange={(newValue) => this.handleChange('addToCart_Translation', newValue)}
                                            label="Add to cart"
                                        />
                                        <TextField
                                            value={this.state.model.buyNow_Translation}
                                            onChange={(newValue) => this.handleChange('buyNow_Translation', newValue)}
                                            label="Buy now"
                                        />
                                    </FormLayout.Group>
                                    <FormLayout.Group>
                                        <TextField
                                            value={this.state.model.soldOut_Translation}
                                            onChange={(newValue) => this.handleChange('soldOut_Translation', newValue)}
                                            label="Sold out"
                                        />
                                        <TextField
                                            value={this.state.model.viewDetails_Translation}
                                            onChange={(newValue) => this.handleChange('viewDetails_Translation', newValue)}
                                            label="View details"
                                        />
                                    </FormLayout.Group>
                                    <FormLayout.Group>
                                        <TextField
                                            value={this.state.model.addedToCartMessage_Translation}
                                            onChange={(newValue) => this.handleChange('addedToCartMessage_Translation', newValue)}
                                            label="Added to cart message"
                                        />
                                        <TextField
                                            value={this.state.model.viewCart_Translation}
                                            onChange={(newValue) => this.handleChange('viewCart_Translation', newValue)}
                                            label="View cart"
                                        />
                                    </FormLayout.Group>
                                    <FormLayout.Group>
                                        <TextField
                                            value={this.state.model.or_Translation}
                                            onChange={(newValue) => this.handleChange('or_Translation', newValue)}
                                            label="or"
                                        />
                                        <TextField
                                            value={this.state.model.continueShopping_Translation}
                                            onChange={(newValue) => this.handleChange('continueShopping_Translation', newValue)}
                                            label="Continue shopping"
                                        />
                                    </FormLayout.Group>
                                </FormLayout>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection
                            title="Look and feel"
                        >
                            <Card>
                                <Card.Section title="Quick view button">
                                    <FormLayout>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Text color"
                                                fieldName="buttonColor"
                                                value={this.state.model.buttonColor}
                                                handleChange={this.handleChange}
                                            />
                                            <ColorPickerCustom
                                                label="Background color"
                                                fieldName="buttonBackgroundColor"
                                                value={this.state.model.buttonBackgroundColor}
                                                handleChange={this.handleChange}
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Border color"
                                                fieldName="buttonBorderColor"
                                                value={this.state.model.buttonBorderColor}
                                                handleChange={this.handleChange}
                                            />
                                            <div></div>
                                        </FormLayout.Group>
                                    </FormLayout>
                                </Card.Section>
                                <Card.Section title="Add to cart button">
                                    <FormLayout>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Text color"
                                                fieldName="atcColor"
                                                value={this.state.model.atcColor}
                                                handleChange={this.handleChange}
                                            />
                                            <ColorPickerCustom
                                                label="Background color"
                                                fieldName="atcBackgroundColor"
                                                value={this.state.model.atcBackgroundColor}
                                                handleChange={this.handleChange}
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Border color"
                                                fieldName="atcBorderColor"
                                                value={this.state.model.atcBorderColor}
                                                handleChange={this.handleChange}
                                            />
                                            <div></div>
                                        </FormLayout.Group>
                                    </FormLayout>
                                </Card.Section>
                                <Card.Section title="Buy now button">
                                    <FormLayout>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Text color"
                                                fieldName="buyNowColor"
                                                value={this.state.model.buyNowColor}
                                                handleChange={this.handleChange}
                                            />
                                            <ColorPickerCustom
                                                label="Background color"
                                                fieldName="buyNowBackgroundColor"
                                                value={this.state.model.buyNowBackgroundColor}
                                                handleChange={this.handleChange}
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Border color"
                                                fieldName="buyNowBorderColor"
                                                value={this.state.model.buyNowBorderColor}
                                                handleChange={this.handleChange}
                                            />
                                            <div></div>
                                        </FormLayout.Group>
                                    </FormLayout>
                                </Card.Section>
                                <Card.Section title="View details button">
                                    <FormLayout>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Text color"
                                                fieldName="viewDetailsColor"
                                                value={this.state.model.viewDetailsColor}
                                                handleChange={this.handleChange}
                                            />
                                            <ColorPickerCustom
                                                label="Background color"
                                                fieldName="viewDetailsBackgroundColor"
                                                value={this.state.model.viewDetailsBackgroundColor}
                                                handleChange={this.handleChange}
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Border color"
                                                fieldName="viewDetailsBorderColor"
                                                value={this.state.model.viewDetailsBorderColor}
                                                handleChange={this.handleChange}
                                            />
                                            <div></div>
                                        </FormLayout.Group>
                                    </FormLayout>
                                </Card.Section>
                                <Card.Section title="Product prices">
                                    <FormLayout>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Price color"
                                                fieldName="productPriceColor"
                                                value={this.state.model.productPriceColor}
                                                handleChange={this.handleChange}
                                            />
                                            <ColorPickerCustom
                                                label="Compare price color"
                                                fieldName="productComparePriceColor"
                                                value={this.state.model.productComparePriceColor}
                                                handleChange={this.handleChange}
                                            />
                                        </FormLayout.Group>
                                    </FormLayout>
                                </Card.Section>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.Section>
                            {/*{window.innerWidth < 768 ?*/}
                            {/*<LegacyStack alignment="center" distribution="center">*/}
                            {/*    <PageActions primaryAction={{ content: 'Save', onAction: () => { this.saveChanges() } }} />*/}
                            {/*</LegacyStack>    */}
                            {/*: */}
                            {/*    <PageActions primaryAction={{ content: 'Save', onAction: () => { this.saveChanges() } }} />*/}
                            {/*}*/}
                        </Layout.Section>
                    </Layout>
                </Page >
        );
    }

    async populateData() {
        const response = await fetchApi('api/home/quickView');
        const data = await response.json();

        if (data.redirectUrl) {
            this.props.navigate(data.redirectUrl);
        }
        else {
            this.props.setIsLoading(false);
            this.setState({ initState: data, model: data, loading: false });

            var topNavTimer = setInterval(function(){
                if(window.$('#preview').length > 0){
                    window.$('#preview').sticky({ topSpacing: 0, zIndex: 100 });
                        window.$('#preview').sticky('update');
                }
            },100);
        }
    }

    async saveChanges() {
        this.props.setIsLoading(true);
        const response = await fetchApi('api/home/saveQuickView', { method: 'post', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(this.state.model) });
        const data = await response.json();
        this.props.setIsLoading(false);

        if (response.ok === true) {
            window?.shopify?.saveBar?.hide("satcb-save-bar");

            if (data.redirectUrl) {
                this.props.navigate(data.redirectUrl);
            }
            else {
                this.setState({ initState: Object.assign({}, this.state.model) });
                this.props.setIsDirty(false);
                this.props.setToastActive(true);
            }
        }
    }
}